<form class="form-horizontal">

  <ng-container [ngTemplateOutlet]="controlsTemplate"></ng-container>

  <ng-container *ngIf="showCancelButton || showSubmitButton">

    <div class="col-md-9 col-sm-8 col-xs-12 text-right">

      <ng-container *ngIf="showCancelButton">

        <button class="btn btn-secondary button-cancel"
                type="button"
                (click)="cancelled.emit()">
          {{ cancelLabel }}
        </button>

      </ng-container>

      <ng-container *ngIf="showSubmitButton">

        <button class="btn btn-default button-select"
                type="button"
                [disabled]="!form.valid"
                [ngClass]="form.valid ? 'btn-default' : 'btn-disabled'"
                (click)="submitted.emit()">
          {{ submitLabel }}
        </button>

      </ng-container>

    </div>

  </ng-container>

</form>
